import { MouseEvent, ReactNode } from 'react';

type FilterLinkProps = {
    children: ReactNode;
    onClick: (e: MouseEvent) => void;
};

export const FilterLink = ({ children, onClick }: FilterLinkProps) => (
    <button
        className="font-inherit text-inherit cursor-pointer border-none bg-transparent p-0 text-link-primary underline"
        onClick={onClick}
        type="button"
    >
        {children}
    </button>
);
